import React, { useRef, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { LocalShipping } from '@material-ui/icons';
import { format, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';
import { includes } from 'lodash';

import { ADM, GFE } from '~/constants/perfil';
import { UnidataTable } from '~/components';
import { number } from '~/helpers';
import { recordFiltering } from '~/store/modules/operacaoabastecimento/actions';

import AcertoHodometro from './components/AcertoHodometro';

function OperacaoAbastecimentoList() {
  const dispatch = useDispatch();

  const data = useSelector((state) => state.operacaoabastecimento);
  const modalRef = useRef(null);

  const { gloperfilid } = useSelector((state) => state.user.profile);

  const listaStatusPesquisa = useMemo(() => [
    { label: 'Normal', value: 'Normal' },
    { label: 'Impedimento condutor', value: 'Impedimento condutor' },
    { label: 'Impedimento veículo', value: 'Impedimento veículo' },
    {
      label: 'Impedimento condutor e veículo',
      value: 'Impedimento condutor e veículo',
    },
    { label: 'Outros', value: 'Outros' },
  ]);

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'movi_datahora_inicio',
        label: 'Data Inicial',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'movi_datahora_fim',
        label: 'Data Final',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      { id: 'poco_descricao', label: 'Posto', filter: { type: 'text' } },
      {
        id: 'bico_numero',
        label: 'Bico',
        align: 'right',
        filter: { type: 'number' },
      },
      { id: 'orga_nome', label: 'Órgão/Entidade', filter: { type: 'text' } },
      { id: 'unid_nome', label: 'Unidade', filter: { type: 'text' } },
      {
        id: 'veic_placa_apresentacao',
        label: 'Veículo',
        filter: { type: 'text' },
      },
      {
        id: 'movi_totalizador_veiculo',
        label: 'Hodômetro',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'prod_display',
        label: 'Produto',
        align: 'right',
        filter: { type: 'text' },
      },
      {
        id: 'movi_encerrante_inicial',
        label: 'Encer. Início',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'movi_encerrante_final',
        label: 'Encer. Fim',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'movi_volume',
        label: 'Volume',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'movi_desc_status',
        label: 'Status',
        align: 'right',
        converter: listaStatusPesquisa,
        filter: {
          type: 'select',
          options: listaStatusPesquisa,
        },
      },
      {
        id: 'cond_cpf',
        label: 'Condutor',
        align: 'left',
        filter: { type: 'text' },
      },
    ],
    []
  );

  const filter = useMemo(
    () => [
      {
        id: 'data_cadastro_ini',
        label: 'Data Inicial',
        type: 'initialdatetime',
        defaultValue: datahorainicial,
      },
      {
        id: 'data_cadastro_fim',
        label: 'Data final',
        type: 'finaldatetime',
        defaultValue: datahorafinal,
      },
    ],
    [datahorainicial, datahorafinal]
  );

  const buttons = useMemo(() => {
    if (includes([ADM, GFE], gloperfilid)) {
      return [
        {
          title: 'Acerto de Hodometro',
          action: (value) => modalRef.current.handleToggleModal(value),
          icon: <LocalShipping />,
        },
      ];
    }

    return [];
  }, [gloperfilid, ADM, GFE]);

  const handleUpdate = useCallback(() => {
    dispatch(recordFiltering(data.params));
  }, [data.params]);

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="movi_datahora_inicio ASC"
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        custom={filter}
        redux={data}
        read={recordFiltering}
        actions={buttons}
        detach="poco_descricao"
        view="VW_ABASTECIMENTO"
        reportTitle="Abastecimentos"
      />

      <AcertoHodometro
        ref={modalRef}
        update={handleUpdate}
        name="AcertoHodometro"
      />
    </>
  );
}

export default OperacaoAbastecimentoList;
